module.exports = __webpack_public_path__ + "img/antes_despues_223.37439dab.png";